import Analysis from 'domain/entity/analysis';
import { Result } from 'domain/types';
import SaveToDashboardClient from 'use-case/analysis/saveToDashboard/saveToDashboardClient';
import SaveToDashboardCriteria from 'use-case/analysis/saveToDashboard/saveToDashboardCriteria';

export type SaveToDashboardResult = Result<Analysis>;
export type SaveToDashboard = (criteria: SaveToDashboardCriteria) => Promise<SaveToDashboardResult>;

export default (saveToDashboardClient: SaveToDashboardClient): SaveToDashboard => (
    criteria: SaveToDashboardCriteria
): Promise<SaveToDashboardResult> => saveToDashboardClient(criteria);
